/* eslint-disable */
import axios from 'axios'

export default {
    namespaced: true,
    state: {
        statusList: [],
        singleStatus: {},
    },
    mutations: {
        setStatusList(state, list) {
            state.statusList = list
        },
        addNewStatus(state, jsstatus) {
            state.statusList.push(jsstatus)
        },
        setSingleStatus(state, jsstatus) {
            state.singleStatus = jsstatus
        },
        deleteStatus(state, jsid) {
            var index = state.statusList.findIndex((stat) => stat.id == jsid)
            state.statusList.splice(index, 1)
        },
        clearStatus(state) {
            state.singleStatus = {
                code: '',
                description: '',
            }
        },
    },
    getters: {},
    actions: {
        getStatusList({ commit }) {
            axios
                .get('/api/status')
                .then((result) => commit('setStatusList', result.data))
                .catch(console.error)
        },
        async getSingleStatus({ commit }, id) {
            await axios
                .get('/api/status/' + id)
                .then((result) => {
                    commit('setSingleStatus', result.data[0])
                })
                .catch((e) => {
                    console.log(e.response)
                })
        },
        async createNewStatus({ commit }, status) {
            await axios
                .post('/api/status', status)
                .then((result) => {
                    commit('addNewStatus', result.data)
                })
                .catch((e) => {
                    console.log(e)
                })
        },
        async updateStatus({ commit }, status) {
            await axios
                .put('/api/status', status)
                .then((result) => {})
                .catch((e) => {
                    console.log(e)
                })
        },
        async deleteStatus({ commit }, id) {
            await axios.delete('/api/status/' + id).then(() => {
                commit('deleteStatus', id)
            })
        },
        clearStatus({ commit }) {
            commit('clearStatus')
        },
    },
}